import { render, staticRenderFns } from "./TicketListView.vue?vue&type=template&id=28f8a3e5&scoped=true"
import script from "./TicketListView.vue?vue&type=script&lang=js"
export * from "./TicketListView.vue?vue&type=script&lang=js"
import style0 from "./TicketListView.vue?vue&type=style&index=0&id=28f8a3e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f8a3e5",
  null
  
)

export default component.exports